import React from "react";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";
import "./OGUK.css";
const OGUK: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"OGUK / OEUK Oil & Gas UK Medical Certificate"}>
        <div
          className="oguk-container"
          style={{
            color: "#000866",
            marginLeft: "20px",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <p>
            Oil & Gas UK / Offshore Energies UK is the voice of offshore
            industry. It is the leading representative body for the UK offshore
            oil & gas industry. Its aim is to strengthen the long-term health of
            the offshore oil and gas industry in the United Kingdom by working
            closely with companies across the sector, governments and all other
            stakeholders to address the issues that affect your business. We are
            certified medical providers for OGUK/ OEUK (Oil and Gas UK
            Physicals) also called UKOOA (United Kingdom Offshore Operators
            Association Physicals)
          </p>
          <h3>OGUK/OEUK - Standard Offshore Medical</h3>
          <p>
            This is the standard offshore medical fitness assessment which is
            required for all offshore workers. Appointment is booked for 60
            minutes. You will need to present valid form of identity as
            Passport.
          </p>
          <h3>OGUK/OEUK - Fitness To Train Medical- FTT</h3>
          <p>
            This is an additional fitness certificate which is required for
            survival course trainees for in-water training exercises with
            compressed-air emergency breathing apparatus (EBS). This assessment
            will classify trainees as either ‘fit’ or ‘unfit’ for in-water EBS
            training as simply as possible. It is understood that examinees
            found unfit for in-water EBS training will likely be permitted to
            complete survival training by ‘dry’ EBS training exercises only.
            This is 60 min appointment.
          </p>
          <h3>
            OGUK/OEUK - Emergency Response Team Duties- ERT (Includes Chester
            Step Test)
          </h3>
          <p>
            This is an additional OGUK/OEUK fitness certificate required for
            Emergency Response Team members. Higher level of fitness is required
            for this role to fulfil a range of duties including firefighting,
            assisting with a controlled platform evacuation and casualty search
            and rescue. This assessment takes 60 minutes.
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default OGUK;
